import { META_HTML_TITLE } from "@core/constants";
import { RouterHelpers } from "@core/helpers";
import { i18n } from "@core/plugins/i18n";

/**
 * This navigation guard translates and writes the HTML title tag
 * @example
 * meta: { [META_HTML_TITLE]: "PAGES.LOGIN.@TITLE" }
 */
export async function htmlTitleGuard(to, from, next) {
  // we take the titles of all the ancestors
  // in reverse in order to display ordered by ancestry
  // the plan is to display rootTitle - parentTitle - enfantTitle
  const titles = [...RouterHelpers.getAllRoutesMeta(to, META_HTML_TITLE)].reverse();
  const translatedTitles = titles.map((title) => i18n.global.t(title));
  document.title = translatedTitles.join(" - ");

  return next();
}
